

export const debounce = (func, wait, immediate) => {
	var timeout

	return function() {
		var context = this, args = arguments
		var later = function() {
			timeout = null
			if (!immediate) func.apply(context, args)
		}

		var callNow = immediate && !timeout

		clearTimeout(timeout)
		timeout = setTimeout(later, wait)

		if (callNow) func.apply(context, args)
	}
}

export const hash = (str) => {
  var hash = 0, i, chr

  if (str.length === 0) return hash

  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i)
    hash  = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }

  return hash
}

export const clone = (obj) => {
	return JSON.parse(JSON.stringify(obj))
}

/** 
  This handles a weird edge case caused by the theme editor.
  When customizing a theme, for some reason HTML comments are injected
  into templates, breaking the response data. This means we need to
  remove the comments and parse it back into JSON format, allowing for
  the data to load properly when the theme editor is open.

  @param data The response to check.
*/
export const parseDataForEditor = data => {
  if(typeof data === 'string') {
    let parsed = data.replace(/<!--[\s\S]*?-->/g, '')

    try {
      return JSON.parse(parsed)
    } catch (error) {
      console.error('Could not parse data:', data)
      return
    }
  }

  return data
}


export const embedVideoIframeAttributes = (url, options = { background: false }) => {
  const HOST = {
    VIMEO: 'VIMEO',
    YOUTUBE: 'YOUTUBE'
  };

  // console.log({ url, options });
  url = new URL(url);
  let host, videoId;

  if (url.hostname === 'youtube.com' || url.hostname === 'www.youtube.com') {
    host = HOST.YOUTUBE;
    if (url.pathname === '/watch') {
      // https://www.youtube.com/watch?v=abc123
      videoId = url.searchParams.get('v');
    } else {
      // https://www.youtube.com/embed/abc123
      videoId = /\/embed\/(.+)/.exec(url.pathname)[1];
    }
  } else if (url.hostname === 'vimeo.com') {
    host = HOST.VIMEO;
    // https://vimeo.com/123456
    videoId = /\/(\d+)/.exec(url.pathname)[1];
  } else if (url.hostname === 'player.vimeo.com') {
    host = HOST.VIMEO;
    // https://player.vimeo.com/video/123456
    videoId = /\/video\/(\d+)/.exec(url.pathname)[1];
  }

  const attributes = {
    frameborder: '0',
    allowfullscreen: true
  };

  let embedUrl;
  if (host === HOST.YOUTUBE) {
    embedUrl = new URL(`https://www.youtube.com/embed/${videoId}`);
    embedUrl.searchParams.set('enablejsapi', 1);
    if (options.background) {
      embedUrl.searchParams.set('controls', 0);
      embedUrl.searchParams.set('autoplay', 1);
      embedUrl.searchParams.set('loop', 1);
      embedUrl.searchParams.set('modestbranding', 1);
    }
    attributes.src = embedUrl.toJSON();
    attributes.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
  }
  if (host === HOST.VIMEO) {
    embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);
    if (options.background) {
      /*
      Adding this parameter will have the following effect:
        All player toggles and elements will be turned off (including the play/pause button)
        The video will automatically loop
        The video will be set to autoplay
        The video will be muted
      */
      embedUrl.searchParams.set('background', true);
    }
    attributes.src = embedUrl.toJSON();
    attributes.allow = 'autoplay; fullscreen';
  }

  // console.log({ attributes });
  return attributes;
}
